export default {
    1: 'Pre-Trial',
    2: 'Pre-Discovery',
    3: 'Pre-Court Resolution',
}